import {Nullable} from "@/general/custom-types/CustomTypes";

export class CalculationRequestFormModel {
  id?: Nullable<number>;
  facilities?: Nullable<number[]>;
  sensors?: Nullable<number[]>;
  start?: Nullable<string>;
  end?: Nullable<string>;
  shouldDeleteBeforeCalculation?: Nullable<boolean>;
  parser?: Nullable<boolean>;
  newParser?: Nullable<boolean>;
  virtualCalculation?: Nullable<boolean>;
  hourAggregation?: Nullable<boolean>;
  dailyAggregation?: Nullable<boolean>;
  monthlyAggregation?: Nullable<boolean>;
  customer?: Nullable<number>;
  color?: Nullable<boolean>;

  constructor(
    id?: Nullable<number>,
    facilities?: Nullable<number[]>,
    sensors?: Nullable<number[]>,
    start?: Nullable<string>,
    end?: Nullable<string>,
    parser?: Nullable<boolean>,
    newParser?: Nullable<boolean>,
    shouldDeleteBeforeCalculation?: Nullable<boolean>,
    virtualCalculation?: Nullable<boolean>,
    hourAggregation?: Nullable<boolean>,
    dailyAggregation?: Nullable<boolean>,
    monthlyAggregation?: Nullable<boolean>,
    customer?: Nullable<number>,
    color?: Nullable<boolean>
  ) {
    this.id = id;
    this.facilities = facilities;
    this.sensors = sensors;
    this.start = start;
    this.end = end;
    this.parser = parser;
    this.newParser = newParser;
    this.virtualCalculation = virtualCalculation;
    this.hourAggregation = hourAggregation;
    this.dailyAggregation = dailyAggregation;
    this.monthlyAggregation = monthlyAggregation;
    this.shouldDeleteBeforeCalculation = shouldDeleteBeforeCalculation;
    this.customer = customer;
    this.color = color;
  }
}
